import { gql } from '@apollo/client';

/**
 * GraphQL Mutations
 *
 * All mutations for creating, updating, and deleting data
 */

// Create a new word
export const CREATE_WORD = gql`
  mutation CreateWord($input: CreateWordInput!) {
    createWord(input: $input) {
      id
      hanzi
      pinyin
      image
      audio
      difficulty
      hskLevel
      topics
      meanings {
        partOfSpeech
        definition
        examples {
          cn
          en
          pinyin
          audio
        }
      }
      createdAt
      updatedAt
    }
  }
`;

// Update an existing word
export const UPDATE_WORD = gql`
  mutation UpdateWord($id: ID!, $input: UpdateWordInput!) {
    updateWord(id: $id, input: $input) {
      id
      hanzi
      pinyin
      image
      audio
      difficulty
      hskLevel
      topics
      meanings {
        partOfSpeech
        definition
        examples {
          cn
          en
          pinyin
          audio
        }
      }
      createdAt
      updatedAt
    }
  }
`;

// Delete a word
export const DELETE_WORD = gql`
  mutation DeleteWord($id: ID!) {
    deleteWord(id: $id)
  }
`;
